import React, { useContext, useRef } from 'react'
import { useEffect, useState } from 'react'
import { Input, Select, Modal, Form, Button, Typography, Table, Popconfirm, notification, Tooltip } from 'antd'
import { observer } from 'mobx-react-lite'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../hooks'
import styled from 'styled-components'
import { PlusOutlined } from '@ant-design/icons'
import type { FormInstance } from 'antd/es/form'
import { debounce, isEmpty, size } from 'lodash'
import { formatCurrency, showMessageError } from 'src/helpers/functions'
import { getStatusOrder, DATE_TIME_FORMAT_CLIENT_short, DELIVERY_CONST, GKE_SERVICES } from 'src/helpers/constants'
import moment from 'moment'
import { Loading } from 'src/common'
import useWindowDimensions from 'src/common/useWindowDimensions'

const formItemLayout = {
   labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
   },
   wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
   }
}

export const ModalWrapper = styled.div`
   .ant-table-wrapper {
      overflow: scroll !important;
      scrollbar-width: thin;
      scrollbar-color: #c1c1c1 #f1f1f1;
   }

   .ant-table {
      overflow: visible !important;
   }

   .ant-table-content {
      overflow: scroll !important;
      scrollbar-width: thin;
      scrollbar-color: #c1c1c1 #f1f1f1;
   }

   .ant-table-body {
      overflow: scroll !important;
      scrollbar-width: thin;
      scrollbar-color: #c1c1c1 #f1f1f1;
   }

   .ant-table-wrapper::-webkit-scrollbar,
   .ant-table-content::-webkit-scrollbar,
   .ant-table-body::-webkit-scrollbar {
      width: 12px !important;
      height: 12px !important;
      -webkit-appearance: none;
   }

   .ant-table-wrapper::-webkit-scrollbar-track,
   .ant-table-content::-webkit-scrollbar-track,
   .ant-table-body::-webkit-scrollbar-track {
      background: #f1f1f1 !important;
      border-radius: 6px !important;
   }

   .ant-table-wrapper::-webkit-scrollbar-thumb,
   .ant-table-content::-webkit-scrollbar-thumb,
   .ant-table-body::-webkit-scrollbar-thumb {
      background-color: #c1c1c1 !important;
      border-radius: 6px !important;
      border: 2px solid #f1f1f1 !important;
   }

   .ant-table-wrapper::-webkit-scrollbar-thumb:hover,
   .ant-table-content::-webkit-scrollbar-thumb:hover,
   .ant-table-body::-webkit-scrollbar-thumb:hover {
      background-color: #a1a1a1 !important;
   }

   .ant-table-wrapper::-webkit-scrollbar-corner,
   .ant-table-content::-webkit-scrollbar-corner,
   .ant-table-body::-webkit-scrollbar-corner {
      background: #f1f1f1 !important;
   }

   .editable-cell {
      position: relative;
   }

   .editable-cell-value-wrap {
      padding: 5px 12px;
      cursor: pointer;
   }

   .editable-row:hover .editable-cell-value-wrap {
      padding: 4px 11px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
   }

   [data-theme='dark'] .editable-row:hover .editable-cell-value-wrap {
      border: 1px solid #434343;
   }
`
const PreviewFileImport = observer((props: any) => {
   const { t } = useTranslation()

   const { items, dataInsert, visible, onOk, onCancel, onlyView } = props
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const UserStore = useStore('UserStore')
   const ProductStore = useStore('ProductStore')
   const [loading, setLoading] = useState(false)

   const onFinish = async () => {
      const hasError = items.find((item: any) => item.errors && size(item.errors) > 0)
      if (hasError) {
         showMessageError('File có lỗi, vui lòng kiểm tra lại')
         return
      }

      setLoading(true)

      const result = await ProductStore.insertMultiple(dataInsert)

      if (result?.code === 200) {
         notification.success({
            message: 'Thành công',
            description: `Import đơn hàng thành công!`
         })
         onOk()
      } else {
         showMessageError(result?.message || 'Import đơn hàng thất bại, vui lòng thử lại')
      }
      setLoading(false)
   }

   let columns = [
      {
         title: 'Xác thực',
         dataIndex: 'errors',
         key: 'errors',
         width: 100,
         render: (value: any) => {
            return (
               <span className="txtMax2Line" style={{ color: isEmpty(value) ? '#038fde' : 'red', cursor: 'pointer' }}>
                  <Tooltip placement="top" title={(value || []).join(', ')}>
                     {isEmpty(value) ? 'Đã xác thực' : (value || []).join(', ')}
                  </Tooltip>
               </span>
            )
         }
      },
      {
         title: 'name',
         dataIndex: 'name',
         key: 'name',
         width: 140,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'images',
         dataIndex: 'images',
         key: 'images',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'tags',
         dataIndex: 'tags',
         key: 'tags',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{(value || []).join(', ')}</span>
         }
      },
      {
         title: 'description',
         dataIndex: 'description',
         key: 'description',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'weigh',
         dataIndex: 'weigh',
         key: 'weigh',
         width: 100,
         render: (value: any) => {
            return (
               <span className="txtMax2Line">{value && value.length > 30 ? value.slice(0, 30) + '...' : value}</span>
            )
         }
      },
      {
         title: 'sellerIDs',
         dataIndex: 'sellerIDs',
         key: 'sellerIDs',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{(value || []).join(', ')}</span>
         }
      },
      {
         title: 'baseCost',
         dataIndex: 'baseCost',
         key: 'baseCost',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'shippingFee',
         dataIndex: 'shippingFee',
         key: 'shippingFee',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'packingFee',
         dataIndex: 'packingFee',
         key: 'packingFee',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'handingFee',
         dataIndex: 'handingFee',
         key: 'handingFee',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'labelFee',
         dataIndex: 'labelFee',
         key: 'labelFee',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      }
   ]

   return (
      <Modal
         width={'90%'}
         style={{ maxWidth: '2000px' }}
         visible={visible}
         centered
         title={'Preview file import'}
         okText={'Gửi'}
         cancelText={t(GLOBAL_CLIENT.close)}
         onCancel={onCancel}
         onOk={onFinish}
      >
         <ModalWrapper style={{ maxWidth: '2000px' }}>
            <Loading isLoading={loading}></Loading>
            <Table
               scroll={{ x: 'max-content', y: 400 }}
               columns={columns}
               dataSource={items}
               rowKey="id"
               pagination={false}
            />
         </ModalWrapper>
      </Modal>
   )
})

export default PreviewFileImport
